<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="pl-9">{{ isEditMode ? $t('common.editRow') : $t('common.addNewRow') }}</v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row>
            <v-col v-for="field in fields" :key="field.label" cols="12" sm="6" md="6">
              <vf-currency-input
                v-model="localEditedItem[field.model]"
                :label="field.label"
                dense
                outlined
                persistent-placeholder
                placeholder="0"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pr-9 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeDialog">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="primary" @click="saveItem">{{ $t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DEDUCTION_TYPE } from '@/helpers'

export default {
  props: {
    dialog: Boolean,
    editedItem: Object,
    isEditMode: Boolean,
    fields: Array
  },
  data () {
    return {
      localEditedItem: { ...this.editedItem }
    }
  },
  watch: {
    editedItem: {
      handler (newValue) {
        this.localEditedItem = { ...newValue }
      },
      deep: true
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },
    saveItem () {
      let item
      switch (this.localEditedItem.type) {
        case DEDUCTION_TYPE.ON_HOLD:
          item = {
            onHoldPercent: this.localEditedItem.percent,
            onHoldTotalCents: this.localEditedItem.totalCents,
            onHoldCumulativeCents: this.localEditedItem.cumulativeCents,
            onHoldCumulativePreviousCents: this.localEditedItem.cumulativePreviousCents,
            onHoldPaymentCents: this.localEditedItem.paymentCents,
            type: this.localEditedItem.type
          }
          break
        case DEDUCTION_TYPE.DEDUCTION:
          item = {
            deductionPercent: this.localEditedItem.percent,
            deductionTotalCents: this.localEditedItem.totalCents,
            deductionCumulativeCents: this.localEditedItem.cumulativeCents,
            deductionCumulativePreviousCents: this.localEditedItem.cumulativePreviousCents,
            deductionPaymentCents: this.localEditedItem.paymentCents,
            type: this.localEditedItem.type
          }
          break
        case DEDUCTION_TYPE.RETENTION:
          item = {
            retentionPercent: this.localEditedItem.percent,
            retentionTotalCents: this.localEditedItem.totalCents,
            retentionCumulativeCents: this.localEditedItem.cumulativeCents,
            retentionCumulativePreviousCents: this.localEditedItem.cumulativePreviousCents,
            retentionPaymentCents: this.localEditedItem.paymentCents,
            type: this.localEditedItem.type
          }
          break
        default:
          item = this.localEditedItem
      }
      this.$emit('saveItem', item)
      this.closeDialog()
    }
  }
}
</script>
